import {useRef} from 'react'
import NumberTicker from 'components/magicui/NumberTicker'

/**
 * A live Sharpenny balance. Renders the current number without fuss on
 * mount, then springs to each new value (Magic UI Number Ticker) so an
 * earn or a spend is visibly the balance moving.
 */
const CoinBalance = ({value, className, ...props}) => {
  const n = Number(value) || 0
  const start = useRef(n)
  return (
    <NumberTicker
      value={n}
      startValue={start.current}
      className={className}
      {...props}
    />
  )
}

export default CoinBalance
